import React, { PureComponent } from 'react'
import { Animated, Easing, TouchableOpacity, View } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import Text, { H1 } from '@dbk/ui-text'
import Dropdown from '@dbk/ui-dropdowns'
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemContent,
  NavigationListItemFooter,
} from '@dbk/ui-list'
import Button from '@dbk/ui-buttons'
import Modal from '@dbk/ui-modal';
import { Close, Info2 } from '@dbk/ui-icons';
import Search from '@dbk/ui-search';
import SearchWithoutCircleIcon from '../../../common/components/icons/search-without-circle';
import ScrollTopOnMount from '../../../components/common/scroll-top-on-mount'
import styles from './payment-destination.styles'
import { PALETTE, CANADIAN_COUNTRY,ROUTES, WARNING_ICON, KEY_CODE } from '../../../constants';
import { PAYMENT_TYPE , PAYMENT_BENF_SORT_VALUE} from '../constant';
import { ErrorIcon, WarningIcon } from '../../../components/common/icons';
import PaymentTouchableListItem from '../payment-touchable-list-item';
import { LoadingCircle } from '../../../components/common/loading';
import Popover1 from '@dbk/ui-popover';
import InfoBox from '@dbk/com.db.dbk.ui-info-box';
import { beneficiaryAddressSplitTitleAndBody } from '../../../components/common/text/utils';

const { NEW_DOMESTIC, ADD_BENEFICIARY } = ROUTES.PAYMENT

const DEBOUNCE_TIME = 800;
const footerLabelStyle = {
  color: PALETTE.secondaryText,
  display: 'inline',
  flex: 'none',
  maxWidth: 'none',
};
const footerValueStyle = {
  color: PALETTE.secondaryActive,
  display: 'inline',
  flex: 'none',
  maxWidth: 'none',
};
const footerTextContainerStyle = {
  display: 'block',
  flex: 'none',
  maxWidth: '100%',
};

class PymtDest extends PureComponent {
  isBeneficiaryFlowInternalNavigation = false;
  bannerAnimation = new Animated.Value(1);
  hasStartedBannerAnimation = false;

  state = {
    enableSearch: false,
    pageOffset: 0,
    searchResult: [],
    searchText: '',
    deleteConfirmationModal: false,
    deleteItem: null,
    selectedAssets: null,
    selectedOption: PAYMENT_BENF_SORT_VALUE[0].value,
    successBannerHeight: null,
    isBeneficiaryListLoading: true,
  }

  loadBeneficiaryList = async () => {
    if (this.props.payments.isBeneficiaryBannerFlow) {
      await this.props.payments.getBeneficiaryListAll();
      return;
    }

    await this.props.payments.getBeneficiaryList();
  }

  async componentDidMount(){
    try {
      await this.loadBeneficiaryList();
    } finally {
      this.setState({ isBeneficiaryListLoading: false });
    }
  }

  onSuccessBannerLayout = ({ nativeEvent: { layout: { height } } }) => {
    if (this.hasStartedBannerAnimation || !height) {
      return;
    }

    this.hasStartedBannerAnimation = true;
    this.setState({ successBannerHeight: height }, () => {
      Animated.timing(this.bannerAnimation, {
        toValue: 0,
        duration: 400,
        delay: 3000,
        easing: Easing.out(Easing.cubic),
        useNativeDriver: false,
      }).start(({ finished }) => {
        if (finished) {
          this.props.payments.setBeneficiaryAddressUpdateSuccess(false);
        }
      });
    });
  }

  componentWillUnmount() {
    if (this.props.payments.isBeneficiaryBannerFlow && !this.isBeneficiaryFlowInternalNavigation) {
      this.props.payments.setIsBeneficiaryBannerFlow(false);
    }
  }

  beneficiaryDetail = (row, event) => {
    const { app: { config: { enableStructuredAddress: structuredAddressEnabled } = {} } = {} } = this.props;
    const { payments: { isBeneficiaryBannerFlow } } = this.props;

    const shouldOpenBeneficiaryAdd = structuredAddressEnabled && (isBeneficiaryBannerFlow || (!row?.beneficiaryAddress?.city && !row?.beneficiaryAddress?.country));

    if (shouldOpenBeneficiaryAdd) {
      const editEvent = event || { stopPropagation() {} };
      return this.editBeneficiary(editEvent, row);
    }

    if (isBeneficiaryBannerFlow) {
      return;
    }

    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (!event && row.hasOwnProperty("beneficiaryId"  ))){ 
      const beneficiary = Object.assign({}, row)
      beneficiary.beneficiaryName = `${row.firstName} ${row.lastName ? row.lastName : ''}`
      // commented for now, just in case if any issue persist will revert back
      // beneficiary.accountNo = row.accountNo ? row.accountNo : row.ibanNo
      // beneficiary.swiftCode = "18236b17";
      this.props.payments.setSelectedBeneficiaryBank(beneficiary)
      this.props.changePage(NEW_DOMESTIC)
    }
  }

  renderErrorModal = () => {
    const { payments: { errorMsg } } = this.props;
    return(
      <Modal
      isActive
      onClose={() => this.props.payments.setErrorModal(false)}
      content={
        <div className="small-12 row padding-20">
          <div className="column small-1">
            <ErrorIcon width={30} height={30} />
          </div>
          <div className="column small-11">
            <Text>{errorMsg}</Text>
          </div>
        </div>
      }
    />
    )
  }

  handleSearchChange = (text) => {
    const {
      payments: {beneficiaryList}
    } = this.props;
    var resultantArray = [];
    const searchText = text.toUpperCase();
    beneficiaryList.length>0 && beneficiaryList.map(item => {
      const fullName = item.firstName + " "+ item.lastName;
      if((item.ibanNo && item.ibanNo.toUpperCase().includes(searchText)) || (item.accountNo && item.accountNo.toUpperCase().includes(searchText))
          || (item.firstName && fullName.toUpperCase().includes(searchText))){
            resultantArray.push(item);
          }
    });
    this.setState({
      enableSearch: true,
      searchResult: resultantArray,
      searchText: text
    });
  }
  
  componentDidUpdate(prevProps, prevState){
    if(this.props.payments.beneficiaryList !== prevProps.payments.beneficiaryList && this.state.searchText.length > 0){
      this.handleSearchChange(this.state.searchText);
    }
    if(document.querySelector('button.btnDeleteOk')){
      document.querySelector('button.btnDeleteOk').focus();
    }
  }
  addNewBeneficiary = () => {
    const {
      payments: { setSelectedBeneficiaryBank, setIBAN, getCountryList, setSelectedBeneficiaryDetail },
    } = this.props
    if (this.props.payments.isBeneficiaryBannerFlow) {
      this.isBeneficiaryFlowInternalNavigation = true;
    }
    setSelectedBeneficiaryBank(null);
    setSelectedBeneficiaryDetail(null); //  set benf details  along with benf id
    setIBAN(true)
    getCountryList({ country: "all-country", isAllCountry: true });
    this.props.changePage(ADD_BENEFICIARY)
  }

  filterBenefCanadianRule = (beneficiaryList) => {
    const {
      payments: { selectedCurrency, paymentType },
    } = this.props;

    if (selectedCurrency && selectedCurrency.tech === CANADIAN_COUNTRY.currencyCode && (paymentType.includes(PAYMENT_TYPE.international))) {
      let modifiedBenfList = [];
      beneficiaryList.length>0 && beneficiaryList.map((item, index)=>{
        if(item.address1 && item.address2 && item.address3 && item.address3.toLowerCase() === 'canada'){
          modifiedBenfList.push(item);
        }
      })
      return modifiedBenfList;
    }
    return this.state.selectedOption ? this.sortData(beneficiaryList) : beneficiaryList;
  }

  // Function called on delete action
  deleteBeneficiary = async (event, item) => {
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (event && item)){ 
      event.stopPropagation();
      this.setState({ deleteItem: item.beneficiaryId})
      if(!this.props.payments.templateList){
        // call template list endpoint before showing delete confirmation modal
        await this.props.payments.getTemplateList();
      }
      this.props.payments.setDelConfirmationModal(true);
    }
  }

  // Function called on edit action
  editBeneficiary = async (event, item) => {
    const {
      payments: { setSelectedBeneficiaryBank, setIBAN, getCountryList, setIsPymtEditBenef, setSelectedBeneficiaryDetail, setSearchBankLoading, setPaymentType, paymentType },
    } = this.props
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (event && item)){
      event.stopPropagation();
      if (this.props.payments.isBeneficiaryBannerFlow) {
        this.isBeneficiaryFlowInternalNavigation = true;
      }
      const beneficiary = Object.assign({}, item)
      beneficiary.beneficiaryName = `${item.firstName} ${item.lastName ? item.lastName : ''}`;
      const nextPaymentType = beneficiary.paymentType || paymentType;
      beneficiary.paymentType = nextPaymentType;
      item.ibanNo ? setIBAN(true) : setIBAN(false);
      if (nextPaymentType) {
        await setPaymentType(nextPaymentType);
      }
      setSelectedBeneficiaryBank(beneficiary);
      setSelectedBeneficiaryDetail(beneficiary);
      setSearchBankLoading(true);
      this.props.changePage(ADD_BENEFICIARY);
      setIsPymtEditBenef(true);
      getCountryList({ country: "all-country", isAllCountry: true });
    }
  }

  closeModal = () =>{
    this.props.payments.setDelConfirmationModal(false);
    this.setState({ deleteItem: null})
  }

  confirmModal = () => {
    this.props.payments.deleteBeneficiary(this.state.deleteItem);
  }

  // Function called on change of sort items
  onSortChange = (selectedItem) => {
    this.setState({
      selectedAssets: selectedItem, selectedOption: selectedItem
    });
  }

 //  Function to sort the data
  sortData = (listData) => {
    let modifiedData = listData;
    if(this.state.selectedOption === PAYMENT_BENF_SORT_VALUE[1].value){
      modifiedData = sortBy(listData, e => ((e.firstName && e.firstName.toLowerCase()) + (e.lastName && e.lastName.toLowerCase())));  //WMCE-41811
    }else{
      modifiedData = sortBy(listData, "lastAccessed");
      modifiedData = reverse(modifiedData);
    }
    return modifiedData;
  }

  renderMessage = (content) => {
    const { title, body } = beneficiaryAddressSplitTitleAndBody(content);
    if (!title) return content;
    return (
      <>
        <strong className="beneficiary-banner__message-title">{title}</strong>
        {body}
      </>
    );
  }

  showDeleteConfModal = () =>{
    const { payments : { templateList }} = this.props;
    // check if beneficiary is being used in template or not.
    const isTemplateExist = templateList && templateList.find(e => e.beneficiaryId === this.state.deleteItem);

    const { i18n: { messages }} = this.props;
    return (
      <Modal
        closeButtonLabel="Close"
        isActive={this.props.payments.deleteConfirmationModal && this.state.deleteItem}
        style={styles.modalstyle}
        onClose={this.closeModal}
        header={messages['app.payment.beneficiary.delete.title']}
        content={
          <div className="padding-20">
           {isTemplateExist ? 
            <div className="small-12 row">
            <div className="column small-1">
              <WarningIcon width={WARNING_ICON.width} height={WARNING_ICON.height} color={PALETTE.warning}/>
            </div>
            <div tabIndex={0}className="column small-11 padding-left-10">
              <Text>{messages['app.payment.beneficiary.delete.template.exist']}</Text>
            </div>
          </div> :
          <Text tabIndex={0}>{messages['app.payment.beneficiary.delete']}</Text> }
            <div className="text-right margin-top-20">
              <Button
                tertiary
                onPress={this.closeModal}
                size="large">
                {isTemplateExist ? messages['app.payments.cancelPayment'] :  messages['app.common.alert.no']}
              </Button>
              <Button
                onPress={this.confirmModal}
                className="btnDeleteOk"
                size="large"
                loading={this.props.payments.loading}>
                {isTemplateExist ? messages['app.rmcallback.okMsg'] : messages['app.common.alert.yes']}
              </Button>
            </div>
          </div>
        }
      />)
  }

  render() {
    const {
      i18n: { messages },
      payments: { beneficiaryList, paymentType, beneficiaryAddressUpdateSuccess, loading },
      auth: { addBeneficiaryDisabled },
      banner: { beneficiaryBannerData } = {}
    } = this.props
    const { app: { config: { enableStructuredAddress: structuredAddressEnabled } = {} } = {} } = this.props;
    const isBeneficiaryBannerFlow = this.props.payments.isBeneficiaryBannerFlow;
    const isNewBeneficiaryButtonHidden = isBeneficiaryBannerFlow && structuredAddressEnabled;
    // API sends the beneficiary alert as one string; fall back to the static notice if none is available.
    const displayContent = beneficiaryBannerData?.alertItems?.[0]?.content;
    const listData = this.state.enableSearch ? ( this.state.selectedOption ? this.sortData(this.state.searchResult) : this.state.searchResult): this.filterBenefCanadianRule(beneficiaryList)
    const isBeneficiaryListLoading = this.state.isBeneficiaryListLoading || loading;
    const dropdownOptions =[ { value: PAYMENT_BENF_SORT_VALUE[0].value, label: messages['app.payment.beneficiary.sort.label']},
      { value: PAYMENT_BENF_SORT_VALUE[1].value, label: messages['app.payment.beneDetail.beneficiaryName']}]
   
   const validList = listData && listData.length
    const disableSelection = this.props.payments.isBeneficiaryBannerFlow;
    const showSuccessBanner = structuredAddressEnabled && beneficiaryAddressUpdateSuccess;
    const successBannerHeight = this.state.successBannerHeight;
    const successBannerStyle = successBannerHeight ? {
      height: this.bannerAnimation.interpolate({
        inputRange: [0, 1],
        outputRange: [0, successBannerHeight],
      }),
      marginBottom: this.bannerAnimation.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 14],
      }),
      overflow: 'hidden',
    } : undefined;
    const successBannerTranslateX = this.bannerAnimation.interpolate({
      inputRange: [0, 1],
      outputRange: [-500, 0],
    });
    return (
      <div className="payment-page__destination row">
        <ScrollTopOnMount/>
        <div>
          <div className="title">
            <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'nowrap', minWidth: 0, alignSelf: 'center' }}>
              <H1 tabIndex={0}>{isBeneficiaryBannerFlow && structuredAddressEnabled ? "Beneficiary list" : messages['app.payment.pageTitle.selectBeneficiary']}</H1>
                <span className="info-button" style={{ flexShrink: 0, marginLeft: 5, marginTop: 10 }}>
                  <Popover1
                    mode="popup"
                    orientation="top"
                    showOnHover
                    popOverClassName="cur-bal-popover"
                    arrowColor={PALETTE.secondaryActive}
                    content={<div>{this.renderMessage(displayContent) || messages['app.beneficiary.updateAddress.notice']}</div>}
                    >
                    <div aria-label={messages['app.dashboard.toolTip'] + " " + this.renderMessage(displayContent)}>
                      <Info2 color={PALETTE.primaryText} height={35} width={35}/>
                    </div>
                  </Popover1>
                </span>
              </View>
          <div className="search--header">
            <div className='search--container'>
              <Search
                role="searchbox"
                value={this.state.searchText}
                size= {"large"}
                iconLeft={<SearchWithoutCircleIcon style = {{paddingLeft: 5}} width={24} height ={24} />}
                iconRight={Close}
                placeholder={messages['app.payment.select.searchBenf']}
                onChange = {debounce(this.handleSearchChange, DEBOUNCE_TIME)}
                className="search-button"
              />
            </div>
            <div className="sortHeader">
            <div className="sortSelect" aria-label={messages['app.payment.filter.beneficiaryDropdown']}>
            <div className="sortBy">
              <Text secondary>{messages['app.payment.beneficiary.sort']}</Text>
            </div>
            <Dropdown
              defaultLabel={false}
              className="large-12 login-lang-dropdown"
              size='large'
              fullWidth
              title={messages['app.payment.filter.beneficiaryDropdown']}
              selected={this.state.selectedOption}
              onChange={option => this.onSortChange(option)}
              options={dropdownOptions}
          />
            </div>
            {!isNewBeneficiaryButtonHidden && <div className="button__new-beneficiary">
              <Button
                fullWidth
                tertiary={addBeneficiaryDisabled}
                disabled={addBeneficiaryDisabled}
                size="large"
                onPress={this.addNewBeneficiary}
                testID="btn_newBeneficiaryPayment_paymentDestination_test">
                {messages['app.payment.newBeneficiary']}
              </Button>
            </div>}
            </div>
            </div>
          </div>
          {isBeneficiaryListLoading &&  <div>
              <LoadingCircle isPage={true}/>
          </div>}
          {showSuccessBanner &&
            <Animated.View style={[styles.bannerContainer, successBannerStyle]} onLayout={this.onSuccessBannerLayout}>
              <Animated.View style={{ transform: [{ translateX: successBannerTranslateX }] }}>
                <InfoBox
                  extendable
                  success
                  fullWidth
                  renderMain={messages['app.beneficiary.updateAddress.success']}
                />
              </Animated.View>
            </Animated.View>}
          <div>
            {!isBeneficiaryListLoading && validList > 0 &&
              listData.map((data, beneficiaryIndex) => (
                <TouchableOpacity
                  focusable={false}
                  key={data && (data.accountNo + data.ibanNo + data.beneficiaryId)}
                  style={beneficiaryIndex > 0 ? { marginBottom: 9 } : undefined}
                >
                  <NavigationListItem inverse tabIndex={-1} onClick={() => this.beneficiaryDetail(data)} hasArrow={false} role={disableSelection ? undefined : "link"}>
                    <PaymentTouchableListItem
                      editItem={(e) => this.editBeneficiary(e, data)}
                      deleteItem={(e) => this.deleteBeneficiary(e, data)}
                      item={data}
                      addBeneficiaryDisabled={addBeneficiaryDisabled}
                      aria-hidden="true"
                      children={(
                        <View onKeyDown={disableSelection ? undefined : (e) => this.beneficiaryDetail(data, e)} style={{ flexDirection: 'row', width: '100%', alignItems: 'flex-start', position: 'relative' }}>
                          <View style={{ flex: 2, paddingRight: 12, minWidth: 0 }}>
                            <NavigationListItemHeader tabIndex={data.firstName ? "0" : "-1"}>
                              <Text className={"ben-header-name"}>{data.firstName + ' ' + (data.lastName ? data.lastName : '')}</Text>
                            </NavigationListItemHeader>
                            <NavigationListItemFooter tabIndex={0}>
                              <Text plain style={footerTextContainerStyle}>
                                <span style={footerLabelStyle}>{`${messages['app.incomehistory.accNum']} `}</span><span style={footerValueStyle}>{data.accountNo ? data.accountNo : data.ibanNo}</span>
                              </Text>
                            </NavigationListItemFooter>
                            <NavigationListItemFooter tabIndex={data.bank ? "0" : "-1"}>
                              <Text plain style={footerTextContainerStyle} aria-label={`${data.bank} ${paymentType.includes('domestic') ? (data.ntnlId ? (data.ntnlId.split('').join(' ')) : '') : (data.swiftCode ? (data.swiftCode.split('').join(' ')) : '')}`}>
                                <span style={footerLabelStyle}>{`${messages['app.payments.summary.bank']}: `}</span><span style={footerValueStyle}>{data.bank}</span>
                              </Text>
                            </NavigationListItemFooter>
                            <NavigationListItemFooter tabIndex={(data.cityName || data.country) ? "0" : "-1"}>
                              <Text plain style={footerTextContainerStyle}>
                                <span style={footerValueStyle}>{data.cityName}{data.cityName && data.postalCode ? ',': ''}{data.postalCode}{data.country? "-": ""}{data.country}</span>
                              </Text>
                            </NavigationListItemFooter>
                          </View>
                          {structuredAddressEnabled && (isBeneficiaryBannerFlow || (!data?.beneficiaryAddress?.city && !data?.beneficiaryAddress?.country)) && (
                            <View style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, alignItems: 'flex-end', justifyContent: 'center', paddingRight: 120 }}>
                              <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'nowrap', minWidth: 0 }}>
                                <NavigationListItemContent className="paymentListColumn paymentListCotent" tabIndex={0} color={PALETTE.primaryNegative} style={{ flex: '0 0 auto', width: 'auto', flexShrink: 0, whiteSpace: 'nowrap' }}>
                                  {messages['app.beneficiary.address.updateDetails.label']}
                                </NavigationListItemContent>
                                  <span className="info-button" style={{ flexShrink: 0, marginLeft: 5, marginTop: 5 }}>
                                  <Popover1
                                    mode="popup"
                                    orientation="top"
                                    showOnHover
                                    popOverClassName="cur-bal-popover"
                                    arrowColor={PALETTE.secondaryActive}
                                    content={<div>{messages['app.beneficiary.address.infobutton.text']}</div>}
                                  >
                                    <div aria-label={messages['app.dashboard.toolTip'] + " " + messages['app.beneficiary.address.infobutton.text']}>
                                      <Info2 color={PALETTE.primaryText} height={29} width={29}/>
                                    </div>
                                  </Popover1>
                                </span>
                              </View>
                            </View>
                          )}
                        </View>
                      )}
                    />
                    </NavigationListItem>
                </TouchableOpacity>
              ))}
          </div>
        </div>
        <div className="footer-placeholder"/>
        {this.props.payments.errorModal && this.renderErrorModal()}
        {this.props.payments.deleteConfirmationModal && this.showDeleteConfModal()}
      </div>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    payments: {
      beneficiaryList: true,
      selectedBeneficiaryBank: true,
      setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' },
      setPaymentType: { $set: 'paymentType' },
      isBeneficiaryBannerFlow: true,
      setIsBeneficiaryBannerFlow: { $set: 'isBeneficiaryBannerFlow' },
      beneficiaryAddressUpdateSuccess: true,
      setBeneficiaryAddressUpdateSuccess: { $set: 'beneficiaryAddressUpdateSuccess' },
      isIBANSelected: true,
      setIBAN: { $set: 'isIBANSelected' },
      getCountryList: { $call: 'searchCountry' },
      setSearchBankLoading: { $set: 'searchBankLoading' },
      selectedCurrency: true,
      paymentType: true,
      getBeneficiaryList: {$call: 'getBeneficiaryList'},
      getBeneficiaryListAll: {$call: 'getBeneficiaryListAll'},
      errorModal: true,
      setErrorModal: { $set: 'errorModal'},
      isPymtEditBenef: true,
      setIsPymtEditBenef: { $set: 'isPymtEditBenef' },
      deleteBeneficiary: { $call : 'deleteBeneficiary'},
      deleteConfirmationModal: true,
      setDelConfirmationModal: { $set: 'deleteConfirmationModal'},
      loading: true,
      errorMsg: true,
      setSelectedBeneficiaryDetail: { $set :'selectedBeneficiaryDetail'},
      templateList: true,
      getTemplateList: { $call: 'getTemplateList' },
    },
    app: {
      config: {
        enableStructuredAddress: true,
      },
    },
    banner: {
      beneficiaryBannerData: true,
    },
    auth: {
      addBeneficiaryDisabled: true,
    }
  },
})(PymtDest)
